var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// necessary import format
// see https://stackoverflow.com/questions/44547201/typescript-react-not-importing-correctly
import * as React from 'react';
import { localFormMap } from './connect';
import { logError } from './helpers/utils';
import { init } from './init';
var component = /** @class */ (function (_super) {
    __extends(class_1, _super);
    function class_1(props) {
        var _this = _super.call(this, props) || this;
        _this.dispatch = function (action) {
            if (typeof action === 'function') {
                action(_this.dispatch, function () { return _this.state; });
            }
            else if ((action || {}).formName === _this.config.name) {
                _this.setState(function (prevState) { return _this.reducer(prevState, action); });
            }
            else {
                logError("Skipping dispatch in LocalForm instance '" + _this.config.name + "'.");
            }
        };
        var _a = init(props.config), initialState = _a.initialState, reducer = _a.reducer, config = _a.config;
        _this.state = initialState;
        _this.reducer = reducer;
        _this.config = config[props.config.name];
        return _this;
    }
    class_1.prototype.render = function () {
        var render = this.props.render;
        var props = localFormMap(this.config)(this.state, this.dispatch);
        return render(props);
    };
    return class_1;
}(React.Component));
// tslint:disable-next-line:variable-name
export var LocalForm = component;
//# sourceMappingURL=LocalForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/yarfl/es/LocalForm.js
// module id = 348
// module chunks = 0